import React from 'react';
import './Loader.css';

const Loader = ({ fullPage = false, size = "medium", text = "", showSpinner = true, bottomSpinner = false }) => {
  return (
    <div className={`premium-loader-container ${fullPage ? 'full-page' : ''} ${size} ${bottomSpinner ? 'has-bottom-spinner' : ''}`}>
      <div className="premium-loader-content">
        {text && <p className="loader-text">{text}</p>}
        {showSpinner && (
          <div className={bottomSpinner ? "bottom-spinner-wrapper" : "spinner-wrapper"}>
            <div className="spinner-ring outer"></div>
            <div className="spinner-ring middle"></div>
            <div className="spinner-ring inner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;
